import createManagementPageLifecycle from "@shared/createManagementPageLifecycle.cjs";

export default createManagementPageLifecycle({
  navbar: "6",
  navbarHook: "mounted",
  loadMethods: ["loadNotifications"],
});
